'use client';

type IServiceCardProps = {
  id: number;
  icon: JSX.Element;
  service_type_name: string;
  selected: boolean;
};

export const BusinessServiceTypeSection = ({
  icon,
  service_type_name,
  selected,
}: IServiceCardProps) => {
  return (
    <div
      className={`${selected ? 'border-foreground bg-background border' : 'text-muted-foreground bg-muted'} cursor-pointer space-y-1 rounded-lg p-5 font-semibold hover:opacity-70`}
    >
      <div>{icon}</div>
      <div className="text-nowrap">{service_type_name}</div>
    </div>
  );
};
